import React from "react";
import Column from "./components/Column";


interface FooterNavigationComponentProps {
    fields?: any;
    rendering?: any;
    sitecoreContext?: { pageEditing?: boolean };
}


const FooterNavigationComponent: React.FC<FooterNavigationComponentProps> = ({
    fields,
    rendering,
    sitecoreContext,
}) => {
    const isEditing = sitecoreContext?.pageEditing;

    const linkSection = fields?.data?.model?.linkSection;

    return (
        <>

            <footer
                id="footer-content"
                className="imc-footer section-wrapper imc-section--relative"
            >
                <div className="imc-section imc-section--relative imc-section--footer imc-content--footer imc-section--padded-top-none imc-section--padded-bottom-jumbo imc-section--padded-top-desktop-jumbo imc-section--padded-left-desktop-xlarge imc-section--padded-right-desktop-xlarge imc-section--padded-left-none imc-section--padded-right-none">
                    {!fields && isEditing && (
                        <h1 className="alarm">Datasource isn't set.</h1>
                    )}

                    {!fields && !isEditing && (
                        <h1 className="alarm">
                            Data is not provided. Contact administrators, please.
                        </h1>
                    )}

                    {(typeof fields === "undefined" || !fields?.data?.model) && (
                        <>
                            <div className="imc-section imc-section--padded imc-section--full-width-mobile imc-content--desktop-display-flex imc-content--display-flex-grow-1">
                            </div>
                        </>
                    )}
                    {fields?.data?.model && Array.isArray(linkSection) && linkSection.length > 0 && (
                        <nav
                            className="imc-gallery am-grid imc-gallery--1-4 imc-gallery--1-1--tablet imc-gallery--1-1--mobile imc-gallery--50-50 imc-gallery--align-flex-start imc-gallery--justify-left imc-gallery--large-padded"
                            data-expand-collapse="mobile"
                            data-add-flex="true"
                            data-scroll-to-top="true"
                            data-scroll-offset="imc-stickyheader"
                        >
                            {linkSection.map((section, sectionIndex) =>
                                section.column.map((column?: any, colIndex?: number) => (
                                    <Column {...fields.data.model} rendering={rendering} column={column} sectionIndex={sectionIndex} colIndex={colIndex} />
                                ))
                            )}
                        </nav>
                    )}
                </div>

            </footer>
        </>
    );
};

export default FooterNavigationComponent;
